/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Vertify } from "@alex_xu/react-slider-vertify";
import '../../../assets/fonts/styles.css'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Logo from 'assets/images/quizedulogo.png'
import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Material Dashboard 2 PRO React page layout routes
// import pageRoutes from "page.routes";

// Material Dashboard 2 PRO React context
import { Button, List, ListItemButton, ListItemIcon, ListItemText, TextField, Typography, useMediaQuery } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { useAppContext } from 'context/app-context';
import { sendContactInquiry } from 'services/user-services';
import validator from 'validator'

const StyledTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    right: 0,
    textAlign: "center"
  },
  "& .MuiInputLabel-shrink": {
    margin: "0 auto",
    position: "absolute",
    right: "0",
    left: "0",
    top: "-3px",
    width: "150px", // Need to give it a width so the positioning will work
    background: "white" // Add a white bg
    // display: "none" //if you want to hide it completly
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    "& legend ": {
      display: "none" // If you want it then you need to position it similar with above
    }
  },
  "& label.Mui-focused": {
    color: "#51b9f3"
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#a1cd63"
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#a1cd63"
    },
    "&:hover fieldset": {
      borderColor: "#a1cd63"
    },
    "&.Mui-focused fieldset": {
      borderColor: "#a1cd63"
    },
  }
});

function Prices(): JSX.Element {

  const { handleMessage } = useAppContext()
  const [captcha, setCaptcha] = useState(false)
  const isMobile = useMediaQuery('(max-width:499px)')
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [message, setMessage] = useState('')
  const [schoolName, setSchoolName] = useState('')
  const [eanNumber, setEanNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [schoolAddress, setSchoolAddress] = useState('')

  const handleContactInquiry = async () => {
    if (!captcha){
      handleMessage('Du skal udfylde captcha', 'error')
      return
    }
    if (!validator.isEmail(email)) {
      handleMessage('Du skal udfylde en gyldig email', 'error')
      return
    }
    if (!validator.isLength(name, { min: 2 })) {
      handleMessage('Du skal udfylde et gyldigt navn', 'error')
      return
    }
    if (!validator.isLength(message, { min: 2 })) {
      handleMessage('Du skal udfylde en besked', 'error')
      return
    }
    if (!validator.isLength(schoolName, { min: 2 })) {
      handleMessage('Du skal udfylde et skolenavn', 'error')
      return
    }
    if (!validator.isLength(eanNumber, { min: 13 })) {
      handleMessage('Du skal udfylde et gyldigt EAN nummer', 'error')
      return
    }
    if (!validator.isLength(phoneNumber, { min: 8 })) {
      handleMessage('Du skal udfylde et gyldigt telefonnummer', 'error')
      return
    }
    if (!validator.isLength(schoolAddress, { min: 2 })) {
      handleMessage('Du skal udfylde en skoleadresse', 'error')
      return
    }
        
    try {
      await sendContactInquiry(name, email, message, schoolName, eanNumber, schoolAddress, phoneNumber)
      handleMessage('Tak for din bestilling! Vi vender tilbage hurtigst muligt', 'success')
    } catch (error) {
      handleMessage('Der skete en fejl', 'error')
    }
  }

  return (
    <PageLayout background="#ffffff">
      <DefaultNavbar
        routes={[]}
        action={{
          type: "internal",
          route: "/authentication/sign-up",
          label: "Få skoleadgang i dag",
          clickButton: () => navigate('/pris'),
          color: "error",
        }}
      />
        <MDBox
          height="100%"
          paddingTop={isMobile ? 15 : 10}
        >

          <MDBox
            height='100%'
            width='100%'
            sx={{
              backgroundColor: '#ffffff'
            }}
          >
            <MDBox
              display='flex'
              marginTop={10}
              flexDirection='column'
              justifyContent='center'
              alignItems='center'
              height='fit-content'
              width='fit-content'
              mx='auto'
            >
              <MDTypography className='font-teen' fontWeight='bold' variant="h1" textAlign='center' maxWidth={1000} width='90vw'>
                For kun <span className='text-green'>800kr</span> ex moms får jeres skole:
              </MDTypography>
              <MDTypography className='font-teen' variant="h4" maxWidth={900} fontWeight='medium' textAlign='center' width='90vw'>
                <span className='text-blue'>Ubegrænset</span> læreradgang til QuizEdus Quizkort-værktøj i <span className='text-purple'>1 år</span> (365 dage)
              </MDTypography>
              <MDBox
                display='flex'
                marginTop={4}
                marginBottom={1}
                gap={2}
                maxWidth={1200}
              >
                <img width='100%' alt='prices 1' src={require('../../../assets/images/prices-image-1.png')} />
              </MDBox>
              <MDBox
                display='flex'
                marginTop={4}
                marginBottom={1}
                gap={2}
                maxWidth={1200}
              >
                <img width='100%' alt='prices 1' src={require('../../../assets/images/prices-image-2.png')} />
              </MDBox>
              <MDTypography className='text-blue font-teen' variant="h1" maxWidth={900} fontWeight='medium' textAlign='center' width='90vw'>
                Bestil nu og kom i gang i dag!
              </MDTypography>
              <MDBox
                marginTop={4}
                width='100%'
                maxWidth={800}
                display='flex'
                flexDirection='column'
                gap={2}
              >
                <StyledTextField
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="off"
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      textAlign: 'center',
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="Fornavn og efternavn" />
                  <StyledTextField
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="off"
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      textAlign: 'center',
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="E-mail" />
                <StyledTextField
                  value={schoolName}
                  onChange={(e) => setSchoolName(e.target.value)}
                  autoComplete="off"
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      textAlign: 'center',
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="Navn på skole" />
                <StyledTextField
                  value={schoolAddress}
                  onChange={(e) => setSchoolAddress(e.target.value)}
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      input: { textAlign: "center" },
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="Skolens adresse" />
                <StyledTextField
                  value={eanNumber}
                  onChange={(e) => setEanNumber(e.target.value)}
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      input: { textAlign: "center" },
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="EAN nummer" />
                <StyledTextField
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      input: { textAlign: "center" },
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="Telefonnummer" />
                <StyledTextField
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  multiline
                  fullWidth
                  rows={4}
                  InputProps={{
                    inputProps: {
                      style: {
                        textAlign: 'center',
                        padding: '20px 0',
                        justifyContent: "center"
                      }
                    }
                  }}
                  InputLabelProps={{
                    sx: {
                      input: { textAlign: "center" },
                      color: '#51b9f3',
                      fontSize: 25,
                      fontWeight: 1000,
                      "&.MuiOutlinedInput-notchedOutline": { fontSize: 25 }
                    }
                  }} label="Kommentar og evt. bestilling af ekstra brætspil" />
              </MDBox>
              <MDBox mb={2}>
              <Vertify
                width={320}
                height={160}
                visible={true}
                onSuccess={() => setCaptcha(true)}
                onRefresh={() => setCaptcha(false)}
                onFail={() => {setCaptcha(false); handleMessage('Du skal udfylde captcha', 'error')}}
              />
              </MDBox>
              <Button
                style={{marginTop: 16, backgroundColor: '#ee8b5a', color: '#ffffff', fontSize: 25, padding: '35px 40px'}}
                onClick={handleContactInquiry}
              >Bestil</Button>
              <MDTypography marginTop={2} className='text-green' textAlign='center'>Ved spørgsmål: skriv til jesperalbinus@quizedu.dk</MDTypography>
            </MDBox>
          </MDBox>

          <MDBox
            sx={{ background: `#ffffff` }}
          >
            <MDBox
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              width='100vw'

              maxWidth={1272}
              minWidth={isMobile ? 'fit-content' : 500}
              mx='auto'
            >
              <Grid sx={{ my: 4 }} container spacing={4}>
                <Grid item xs={12} sm={6}>
                  <MDBox
                    mx={isMobile ? 4 : 0}
                    marginLeft={{ xs: 'auto', sm: 4 }}
                    marginRight='auto'
                    width='fit-content'
                    height='fit-content'
                  >
                    <img style={{ marginLeft: isMobile ? 'auto' : 60, marginRight: isMobile ? 'auto' : 32 }} src={Logo} alt='quizedu' width={250} height={'100%'} />
                  </MDBox>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MDBox
                    mx={isMobile ? 4 : 0}
                    marginRight={{ xs: 'auto', sm: 4 }}
                    marginLeft='auto'
                    width='fit-content'
                    height='fit-content'
                  >
                    <Typography mx={2} component='b' fontWeight={700}>Følg os på:</Typography>
                    <List>
                      <ListItemButton LinkComponent={Link} target='_blank' href='https://www.facebook.com/profile.php?id=100089081940552' sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}><FacebookIcon /></ListItemIcon>
                        <ListItemText primary="Facebook" />
                      </ListItemButton>
                      <ListItemButton LinkComponent={Link} target='_blank' href='https://www.instagram.com/quizedu.dk' sx={{ py: 0 }}>
                        <ListItemIcon sx={{ minWidth: '30px' }}><InstagramIcon /></ListItemIcon>
                        <ListItemText primary="Instagram" />
                      </ListItemButton>
                    </List>
                  </MDBox>
                </Grid>
              </Grid>

              <hr />
              <Typography textAlign={'center'}>{(new Date()).getFullYear()} QuizEdu.dk. Alle rettigheder forbeholdes</Typography>
            </MDBox>
          </MDBox>

        </MDBox>
    </PageLayout>
  );
}

export default Prices;
